<section id="/guide/agreement">
  <h3 class="guide__heading heading heading_level_3">이용약관</h3>
  <h4 class="guide__heading heading heading_level_4">제1장 총칙</h4>
  <h5 class="guide__heading heading heading_level_5">제 1 조 목적</h5>
  <ol class="guide__text text">
    <li>커피멘토를 운영하는 주식회사 공간몬스터(이하 “회사”라고 합니다)에서 운영하는 홈페이지 (https://www.coffeementor.co.kr, 이하 “홈페이지”라고 합니다)는 아래와 같은 약관에 동의하는 이용자들에게 제공되는 인터넷서비스로, 본 약관은 이용자와 회사 사이에 본 홈페이지 이용에 관한 권리 및 의무를 규정하는 것을 목적으로 합니다.</li>
    <li>홈페이지의 모든 자료는 회사에 의해 자격을 취득한 기타 이해 관계자에 의한 저작권, 등록의장, 등록상표 또는 기타 지적소유권으로 보호되고 있습니다.</li>
    <li>본 홈페이지에 포함된 자료는 이용자에게 정보 제공을 위한 목적으로만 제공됩니다. 이용자는 본 홈페이지의 내용에 대하여 어떤 방법으로도 배포, 출판, 전송, 변경, 전시, 모방작품의 창조 혹은 개발할 수 없습니다. 이용자는 회사의 권한을 보호하여야 하고, 본 홈페이지의 자료를 허가 없이 유용할 수 없습니다. 허가 없이 본 홈페이지의 내용을 유용하는 경우에 회사는 이용자에게 법적, 재정적으로 가능한 기타 추가적인 배상을 청구할 수 있습니다.</li>
    <li>이용자가 제출하는 자료의 내용에 대한 책임은 전적으로 이용자에게 있습니다. 이용자가 제출하는 자료에 불법, 중상모략, 비난 혹은 비도덕적인 내용이 포함되어서는 안됩니다. 이용자는 본 홈페이지에 저작권, 등록상표권, 사생활권 혹은 기타 사적 권리 혹은 소유권을 포함하는 제3자의 권리를 침해하는 어떤 자료도 게시하여서는 안됩니다.</li>
    <li>이용자의 개인정보 보호 및 보안, 개인정보에 대한 수집, 이용 및 저장과 관련한 관행 및 정책에 대하여는 회사의 개인정보취급방침에 의합니다. 개인정보취급방침은 홈페이지에 별도 게시하고 있습니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 2 조 용어의 정의</h5>

  <p class="guide__text text">본 약관에서 사용하는 용어는 다음과 같이 정의합니다.</p>
  <ol class="guide__text text">
    <li>“이용자” 란 홈페이지에 접속하여 홈페이지를 이용하는 회원 및 비회원을 말합니다.</li>
    <li>“회원” 이란 홈페이지에 접속하여 본 약관에 따라 회사 인터넷 회원으로 가입하여 홈페이지가 제공하는 서비스를 받는 자를 말하고, “비회원”이란 회원이 아닌 자를 말합니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 3 조 약관의 효력 및 개정 등</h5>

  <ol>
    <li>본 약관은 그 내용을 회사가 홈페이지에 게시하고, 회원이 홈페이지 회원가입 시 본 약관에 동의함으로써 그 효력이 발생합니다.</li>
    <li>회사는 본 약관을 변경할 수 있으며 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 홈페이지에 그 적용일의 7일전부터 공시하거나 회원이 입력한 가장 최근의 이메일로 전송하는 방법으로 회원에게 고지합니다. 다만, 회원에게 불리한 내용으로 약관을 개정하는 경우에는 적용일로부터 30일 전까지 홈페이지에 공시하고 회원이 입력한 가장 최근의 이메일로 전송하는 방법으로 회원에게 고지합니다.</li>
    <li>변경된 약관은 공시하거나 고지한 적용일로부터 효력이 발생합니다.</li>
    <li>회원이 변경된 약관 사항에 동의하지 않을 경우, 약관의 효력 발생 전일까지 서비스 이용을 중단하거나 회원 탈퇴를 할 수 있으며, 약관의 개정과 관련하여 효력 발생일 전일까지 이의를 제기하지 않는 경우에는 개정된 약관에 동의한 것으로 간주합니다.</li>
  </ol>

  <h4 class="guide__heading heading heading_level_4">제2장 서비스</h4>
  <h5 class="guide__heading heading heading_level_5">제 4 조 회사 서비스에 포함된 회원 게시물의 관리</h5>
  <ol>
    <li>회원이 홈페이지를 이용하여 홈페이지에 게시한 부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등 '게시물'의 저작권은 적법한 저작권자에게 귀속됩니다.</li>
    <li>회원이 홈페이지를 이용하는 경우, 회사는 회원의 프로필 사진 및 게시물(예: 리뷰, 댓글 등)을 회원 서비스 화면에 표시할 수 있습니다. 이 경우, 회사는 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 홈페이지 내 관리기능을 통해 해당 게시물에 대해 삭제, 비공개 등의 조치를 취할 수 있습니다.</li>
    <li>회사는 회원의 게시물을 소중하게 생각하며 게시물이 변조, 훼손, 삭제되지 않도록 최선을 다하여 보호합니다. 그러나 회원의 게시물이 '정보통신망법' 및 '저작권법' 등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 관련법이 정한 절차에 따라 해당 게시물의 게시 중단 및 삭제 등을 요청할 수 있으며, 회사는 관련법에 따라 조치를 취하여야 합니다.</li>
    <li>회사는 전항에 따른 권리자의 요청이 없는 경우라도 권리 침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 '게시물'에 대해 임시 조치 등을 취할 수 있습니다.</li>
    <li>회사는 바람직한 게시판 문화를 활성화하기 위하여 동의 없는 타인의 신상 공개 시 특정부분을 삭제하거나 기호 등으로 수정하여 게시할 수 있습니다.</li>
    <li>게시물에 관련된 제반 권리와 책임은 작성자 개인에게 있습니다. 또 게시물을 통해 자발적으로 공개된 정보는 보호받기 어려우므로 정보 공개 전에 심사숙고 하시기 바랍니다.</li>
    <li>가입 해지 시 회원께서 작성하신 게시물은 자동으로 파기됩니다. 보관을 원하시는 게시물은 미리 회원의 컴퓨터에 저장하셔야 합니다.</li>
    <li>일부 정보는 정당한 사유 또는 목적이 달성되는 등의 경우 삭제될 수 있으며 이러한 사유발생 시 별도 안내 및 적정 절차를 거쳐 삭제 조치될 수 있습니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 5 조 서비스의 중단</h5>
  <ol>
    <li>회사는 컴퓨터 등 정보통신설비의 보수 점검 교체 및 고장, 통신의 두절, 기타 불가항력적 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
    <li>회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상하지 아니합니다. 단 회사의 고의 또는 과실이 있는 경우에는 그러하지 아니합니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 6 조 회원에 대한 통지</h5>
  <ol>
    <li>회사가 회원에 대한 통지를 하는 경우 본 약관에 별도 규정이 없는 한 문자메시지(SMS), 모바일 애플리케이션 푸쉬, 이메일 등으로 할 수 있습니다.</li>
    <li>회사는 회원 전체에 대한 통지의 경우 7일 이상 회사의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 7 조 정보의 제공 및 광고의 게재</h5>
  <ol>
    <li>회사는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 문자메시지(SMS), 모바일 애플리케이션 푸쉬, 이메일 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련법에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지 이메일 등에 대해서 수신 거절을 할 수 있습니다.</li>
    <li>제1항의 정보를 문자메시지(SMS), 모바일 애플리케이션 푸쉬, 이메일 등을 통하여 전송하려고 하는 경우에는 회원의 사전 동의를 받아서 전송합니다. 다만, 회원의 거래관련 정보 및 고객문의 등에 대한 회신에 있어서는 그러하지 않습니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 8 조 업무의 제휴</h5>
  <ol>
    <li>회사는 이용자의 편의를 도모하고 효과적인 서비스 운영을 위해 서비스의 일정 부분에 대해 다른 회사와 제휴할 수 있습니다.</li>
    <li>제휴회사가 서비스와 관련하여 진행한 활동은 회사가 직접 시행한 활동에 준하는 효력이 있습니다.</li>
  </ol>

  <h4 class="guide__heading heading heading_level_4">제3장 기타</h4>
  <h5 class="guide__heading heading heading_level_5">제 9 조 약관의 해석 등</h5>
  <ol>
    <li>본 약관에 명시되지 않은 사항 또는 본 약관 해석상 다툼이 있는 경우에는 이용자와 회사의 합의에 의하여 결정합니다. 다만, 합의가 이루어지지 않은 경우에는 관계법령 및 거래관행에 따릅니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 10 조 책임 제한</h5>
  <ol>
    <li>회사는 천재지변 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없거나 회사의 귀책사유가 없는 경우에는 책임을 지지 않습니다.</li>
    <li>회사는 서비스 이용과 관련하여 이용자의 고의 또는 과실로 인하여 발생한 손해에 관하여 책임을 지지 않습니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 11 조 손해배상</h5>
  <ol>
    <li>이용자가 본 약관의 규정을 위반함으로 인하여 회사에 손해가 발생하게 되는 경우, 이용자는 회사에 발생하는 손해를 배상해야 합니다.</li>
    <li>서비스를 이용하면서 불법행위나 본 약관을 위반하는 행위를 한 이용자로 말미암아 회사가 해당 이용자 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는다면 해당 이용자는 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 당해 이용자는 그로 인하여 회사에 발생한 손해를 배상해야 합니다.</li>
  </ol>

  <h5 class="guide__heading heading heading_level_5">제 12 조 관할법원</h5>
  <ol>
    <li>본 약관과 관련하여 회사와 이용자 사이에 발생한 분쟁에 관한 소송은 회사의 소재지를 관할하는 법원 또는 민사소송법상의 관할법원을 관할법원으로 합니다.</li>
  </ol>

  <p class="text">본 이용약관은 2022년 8월 1일부터 시행합니다.</p>
</section>
